export const isDateExpired = (dateStr?: string): boolean => {
  if (!dateStr) {
    return false
  }

  const inputDate = new Date(dateStr)

  inputDate.setHours(0, 0, 0, 0)

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return inputDate < today
}
